import * as React from 'react';
import * as styles from './TargetingApplication.css';
import { IAChoiceGroup } from './../choiceGroup/ChoiceGroup';
import { TreeTargeting } from './../treeTargeting/TreeTargeting';
import { Environment } from './../../services/Environment';
import { IAToggle } from './../toggle/Toggle';
import { IApplication, IDefaultValues, Instance } from './../../interfaces/IApplication';
import { LocalizationService } from './../../services/LocalizationService';
import { IAIcon } from '../icon/Icon';
import { ITargetingExistingStrucuture } from '../../interfaces/ITargetingExistingStructure';
import { ITargetingGroup } from '../../interfaces/ITargetingGroup';
import { TargetingService } from '../../services/TargetingService';
import { ITargetingApplications } from '../../interfaces/ITargetingApplications';
import { GroupList, GroupListColumnType, GroupListGroup, GroupListItem } from '../../interfaces/IGroupList';
import { ITargetingGroupValues } from '../../interfaces/ITargetingGroupValues';
import { IATooltip } from '../tooltip/Tooltip';
import { IASpinner } from '../spinner/Spinner';
import { TreeTargetingForGroups } from '../treeTargetingForGroups';

export interface ITargetingApplicationSettingsProps {
  open?: boolean;
  close?: () => void;
  onChange?: (newState) => void;
  isApplication?: boolean;
  application?: IApplication;
  item?: any;
  style?: React.CSSProperties;
  highlightColor?: string;
  tenant?: string;
  token?: string;
  environment?: "Development" | "Test" | "Production";
  applicationName?: "Messages" | "Navigator" | "Toolbox" | "Events" | "Content Organizer";
  hideProfileInformation?: boolean;
}

export interface ITargetingApplicationSettingsState {
  radioValue: string;
  color: string;
  storedValues: Array<{ label: string, id: string, value?: boolean }>;
  allValues: boolean;
  useDefaultValues: boolean;
  enableTargeting: boolean;
  treeValues: Array<{ label: string, id: string, field?: string }>;
  isSaving: boolean;
  required: boolean;
  targetingExistingStructure: ITargetingExistingStrucuture;

  applicationSetting: ITargetingApplications;
  application: IApplication;
  selectedValues: any[];
  groups: GroupListGroup[];
  groupsList: ITargetingGroup[];
  groupListItem: GroupListItem[];
  groupedList: GroupList;
  selectedUserGroup: ITargetingGroup;
}

export class IATargetingApplication extends React.Component<ITargetingApplicationSettingsProps, ITargetingApplicationSettingsState> {
  constructor(props: ITargetingApplicationSettingsProps, state: ITargetingApplicationSettingsState) {
    super(props, state);

    this.state = {
      radioValue: "userGroups",
      color: "#025159",
      storedValues: [],
      allValues: false,
      useDefaultValues: false,
      enableTargeting: false,
      treeValues: [],
      isSaving: false,
      required: false,
      targetingExistingStructure: {
        useDefaultStructure: false,
        nodes: []
      },
      applicationSetting: null,
      application: null,
      groupsList: [],
      groupListItem: [],
      groups: undefined,
      groupedList: undefined,
      selectedUserGroup: undefined,
      selectedValues: [],
    }
    // Get groups info
    this.loadGroups();
    // Getting Application information
    this.getApplication();
  }

  public getValues() {
    const treeValues: Array<{ label: string, id: string, field?: string }> = [];
    let required = false;
    let userGroups = [];
    if (this.state.groupsList && this.state.application) {
      if (this.state.groupsList && this.state.groupsList.length) {
        userGroups = this.state.groupsList.map((group) => {
          let storedGroup = this.state.application && this.state.application.default && this.state.application.default.values ? this.state.application.default.values.find(g => g.id === group.id) : undefined;
          required = ((storedGroup && storedGroup.value) ? storedGroup.value : required);
          return { label: group.title, id: group.id, value: this.state.application.default.allValues ? true : ((storedGroup && storedGroup.value) ? storedGroup.value : false) };
        });
      }
      if (this.state.application.default.type === "profileData" && this.state.application.default.values) {
        this.state.application.default.values.forEach(value => {
          treeValues.push({ label: value.label, id: value.id, field: value.field });
        });
        if (treeValues.length > 0) {
          required = true;
        }
      }

      this.setState({ radioValue: this.state.application.default.type, allValues: this.state.application.default.allValues, useDefaultValues: false, storedValues: userGroups, treeValues, required });
    }
  }



  private loadGroups = () => {
    TargetingService.getGroups(this.props.environment, this.props.tenant, this.props.token).then((groups) => {

      this.transformDataToGroupList(groups);
    });
  }

  private getApplication = () => {
    TargetingService.getApplication(this.props.environment, this.props.tenant, this.props.token, this.props.applicationName, true).then((applications) => {
      const applicationSettings = applications?.value[0];
      let application: IApplication;
      const appData = JSON.parse(applicationSettings.defaultValues);
      let defaultValues: IDefaultValues;
      if (!appData || Array.isArray(appData)) {
        const list: any[] = [];
        defaultValues = {
          isEnable: false,
          type: "userGroups",
          values: list,
          allValues: false
        };
        application = {
          id: undefined,
          title: applicationSettings.title,
          name: applicationSettings.title,
          instances: [],
          default: defaultValues
        };
      } else {
        application = appData;
        if (applications && applicationSettings) {
          application.default.type = applicationSettings.applicationSettings?.toLocaleLowerCase() === "profile data" ? "profileData" : "userGroups";
        }
      }

      applicationSettings.application = application;
      let enableTargeting = this.state.enableTargeting;
      let storedValues = this.state.storedValues
      application?.instances?.forEach((instance: Instance) => {
        if (instance?.id === this.props.item?.key) {
          enableTargeting = instance?.isEnable;
          if (instance?.isEnable) {
            storedValues = instance?.values;
          }
        }
      });

      this.setState({ applicationSetting: applicationSettings, application: application, enableTargeting, storedValues });
    });
  }

  public transformDataToGroupList = (groups: ITargetingGroup[]) => {
    let groupsListSorted = groups.sort((g1, g2) => {
      if (g1.title.toLocaleLowerCase() > g2.title.toLocaleLowerCase()) {
        return 1;
      }
      if (g1.title.toLocaleLowerCase() < g2.title.toLocaleLowerCase()) {
        return -1;
      }
      return 0;
    });

    console.log(groupsListSorted);

    this.setState({ groupsList: groupsListSorted });

    const items: GroupListItem[] = [];
    groups.forEach(x => {

      const item = {
        title: x.title,
        id: x.id,
        name: x.title,
        columns: []
      };

      item.columns.push({
        field: "Title",
        title: new LocalizationService().strings.TargetingAdmin_UserGroup_GroupLabel,
        type: GroupListColumnType.Text,
        value: (
          <div style={{ position: 'relative', top: '3px' }}>
            <div style={{ float: 'left', position: 'relative', top: '5px' }}>
              <IAIcon
                title={"People"}
                color={this.props.highlightColor}
                size={17} />
            </div>
            <div style={{ float: 'left', position: 'relative' }}>{x.title}</div>
          </div>
        )
      });

      item.columns.push({
        field: "Edit",
        title: "",
        type: GroupListColumnType.Icon,
        value: true
      });

      let values: ITargetingGroupValues[];
      let valueNames = "";

      if (x.values) {
        values = JSON.parse(x.values) as ITargetingGroupValues[];
        values.forEach((_) => {
          valueNames += _.displayName + "; ";
        });
      }

      item.columns.push({
        field: "Values",
        title: new LocalizationService().strings.TargetingAdmin_UserGroup_GroupValues,
        type: GroupListColumnType.Text,
        value: valueNames
      });

      items.push(item);

    });

    console.log(items);

    this.setState({ groupListItem: items });
    this.getGroups();
  }

  public getGroups(): void {
    const columnsTitle = [{ title: new LocalizationService().strings.TargetingAdmin_UserGroup_GroupLabel, name: "Title" }, { title: "", name: "Edit" }, { title: new LocalizationService().strings.TargetingAdmin_UserGroup_GroupValues, name: "Values" }];
    const items = this.state.groupListItem;
    const newGroup = [{
      name: "group1",
      expanded: true,
      title: "",
      items,
      hideTitle: true,
      borderEveryItem: true
    }];
    const newGroupedList = {
      columns: columnsTitle,
      groups: newGroup,
      hideFirstColumn: true
    };
    this.setState({ groups: newGroup, groupedList: newGroupedList });
  }

  private getSelectedValues(): any[] {
    const selectedValues = [];
    this.state.storedValues?.forEach((item) => {
      if (item.id) {
        selectedValues.push(item.id);
      }
    });
    return selectedValues;
  }

  public render(): JSX.Element {
    if (!this.state.application) {
      return (
        <IASpinner
          color={this.props.highlightColor}
          style={{
            margin: "5px auto"
          }}
        />
      );
    }

    let panel = (
      <div style={this.props.style} className={styles.IA_viewPanelContentWrapper}>
        {/* <div style={{ marginTop: '10px', marginBottom: '10px', fontWeight: 600, fontSize: '17px' }}>{ !this.props.item ? this.props.application.name : `${this.props.application.name} - ${this.props.item.name}`}</div>  */}
        {
          <div>
            <IAToggle
              label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsEnableTarget}
              checked={this.state.enableTargeting}
              onChange={() => {
                this.setState({ enableTargeting: !this.state.enableTargeting }, () => this.props.onChange(this.state));
                this.getValues();
                let allValues = true;
                let required = false;
                if (this.state.radioValue === 'userGroups') {
                  console.log(this.state.storedValues);
                  this.state.storedValues.forEach(item => {
                    if (!item.value) {
                      allValues = false;
                    } else {
                      required = true;
                    }
                  });
                } else {
                  required = this.state.treeValues.length > 0 ? true : false
                  allValues = false;
                }
                this.setState({ allValues, required }, () => this.props.onChange(this.state));
              }}
              style={{
                width: "unset",
                marginRight: 2
              }}
              color={this.state.color}
            />
            <div style={{ position: 'initial', left: '5px', float: "left" }}>
              <IATooltip
                content="Tooltip"
                type={"bubble"}
                styles={{
                  width: 300,
                  color: "#999999",
                  textAlign: "center",
                  marginBottom: "5px"
                }}
                componentContent={
                  <div>
                    <ul>
                      <li>{new LocalizationService().strings.TargetingApplication_EnableTargetingInfo}</li>
                    </ul>
                  </div>
                }>
                <IAIcon
                  title="Info"
                  size={17}
                  color={"#025159"}
                  style={{
                    float: "left"
                  }} />
              </IATooltip>
            </div>
          </div>

        }
        {this.state.enableTargeting &&
          <div>
            {!this.props.isApplication &&
              <div style={{ marginTop: '10px' }}>
                <IAToggle
                  label={`${new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUseDefault}${this.props.applicationName}`}
                  checked={this.state.useDefaultValues}
                  onChange={() => {
                    this.setState({ useDefaultValues: !this.state.useDefaultValues }, () => this.props.onChange(this.state));
                  }}
                  style={{
                    width: "unset"
                  }}
                  color={this.state.color}
                />
              </div>
            }
            {this.props.isApplication && !this.props.hideProfileInformation &&
              <div style={{ marginTop: '10px', marginBottom: '10px', display: 'flex', clear: 'both' }}>
                <div>
                  <IAChoiceGroup
                    // className={styles.IA_defaultChoiceGroup}
                    label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsSelectTarget}
                    selectedKey={this.state.radioValue}
                    highlightColor={this.state.color}
                    options={[
                      {
                        key: 'userGroups',
                        text: new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUserGroups,
                        disabled: false
                      },
                      {
                        key: 'profileData',
                        text: new LocalizationService().strings.TargetingAdmin_ApplicationSettingsProfileData,
                        disabled: false
                      }
                    ]}
                    required={true}
                    onChange={(key) => {
                      this.getValues();
                      let allValues = true;
                      let required = false;
                      if (key === 'userGroups') {
                        console.log(this.state.storedValues);
                        this.state.storedValues.forEach(item => {
                          if (!item.value) {
                            allValues = false;
                          } else {
                            required = true;
                          }
                        });
                      } else {
                        required = this.state.treeValues.length > 0 ? true : false
                        allValues = false;
                      }
                      this.setState({ radioValue: key, allValues, required }, () => this.props.onChange(this.state));
                    }}
                    style={{
                      marginTop: 10
                    }}
                  />
                </div>
              </div>
            }
            {(!this.state.useDefaultValues || this.props.isApplication) && <div>
              {this.state.radioValue === 'userGroups' &&
                <div style={{ clear: 'both', float: "left", marginTop: 20 }}>
                  {new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUserGroupsTarget}<span style={{ color: 'red' }}> *</span>
                  <TreeTargetingForGroups
                    applicationData={this.state.applicationSetting}
                    environment={this.props.environment}
                    tenant={this.props.tenant}
                    application={this.state.applicationSetting?.title?.toLowerCase() as "messages" | "navigator" | "toolbox" | "events" | "content organizer" | "app"}
                    selectedGroupIds={this.getSelectedValues()}
                    showTarget
                    hideOptions
                    highlightColor={this.state.color}
                    onShowTargetChanged={() => { }}
                    onGroupIdsUpdated={(ids: number[]) => {
                      let list = this.state.applicationSetting.targetingGroups;
                      const storedValues = [];
                      list.forEach((listItem) => {
                        if (ids.find(id => `${id}` === `${listItem.id}`)) {
                          storedValues.push({
                            id: listItem.id,
                            label: listItem.title,
                            value: true
                          });
                        }
                      })
                      this.setState({
                        storedValues,
                      }, () => this.props.onChange(this.state));
                    }}
                  />
                </div>
              }
              {this.state.radioValue === 'profileData' &&
                <div style={{ marginBottom: '10px', clear: 'both' }}>
                  <div style={{ marginTop: 10, marginBottom: 3 }}>{new LocalizationService().strings.TargetingAdmin_ApplicationSettingsProfileDataTarget}<span style={{ color: 'red' }}> *</span></div>
                  { /* tslint:disable:no-unused-variable */}
                  <TreeTargeting
                    application={(this.state.application ? this.props.applicationName.toLocaleLowerCase() : this.props.item.name.toLocaleLowerCase()) as "messages" | "navigator" | "toolbox" | "events" | "content organizer"}
                    tenant={`${this.props.tenant}.sharepoint.com`}
                    authToken={this.props.token}
                    environment={this.props.environment}
                    apiUrl={Environment.getEnvironmentForMainAPI(this.props.environment)}
                    currenNodeStructure={this.state.targetingExistingStructure}
                    selectedValues={this.state.treeValues} //Add stored data
                    showTarget={true}
                    onShowTargetChanged={() => { }}

                    onChange={
                      (targetingDataModel, applicationSettings, groupResult, selectAll, targetingExistingStructure) => {
                        const list: any[] = [];
                        targetingDataModel.forEach(items => {
                          list.push(...items.values);
                        });
                        console.log(list);
                        this.setState({ treeValues: list, allValues: selectAll, required: list.length > 0 ? true : false, targetingExistingStructure: targetingExistingStructure }, () => this.props.onChange(this.state));
                        console.log(applicationSettings, groupResult);
                      }}
                    operator={"AND"}
                    // tslint:disable-next-line: no-empty
                    onLogicalOperatorChanged={() => { }}
                    nodeComparison={"label"}
                    highlightColor={this.state.color}
                    hideOptions={true}
                    selectAll={this.state.allValues}
                    showSelectAll={true}
                    isAdmin={true}
                  />
                </div>
              }
            </div>}
          </div>
        }
        <div style={{ clear: 'both' }}></div>

      </div>);

    return panel;
  }
}
